import {EngagementId, PaginationArgs, PopulationId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const population = typedQuery(
  ["tprm", "population", param<PopulationId>("populationId")],
  async populationId => {
    return await api.tprm.populations.get(populationId);
  },
);

export const populationRows = typedQuery(
  ["tprm", "populationRows", param<PopulationId>("populationId"), param<PaginationArgs>("pagination")],
  async (populationId, pagination) => {
    return await api.tprm.populations.listRows(populationId, pagination);
  },
);

export const engagementPopulations = typedQuery(
  ["tprm", "engagementPopulations", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.populations.list(engagementId);
  },
);
